import { render, staticRenderFns } from "./EmailLoginSVG.vue?vue&type=template&id=2924dde0"
import script from "./EmailLoginSVG.vue?vue&type=script&lang=js"
export * from "./EmailLoginSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports